<template>
	<div>
		<breadcrumbs />

		<loading :active.sync="isLoading"></loading>

		<div class="content-i">
			<div class="content-box">
				<div class="row pt-4">
					<div class="col-sm-12">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">
								{{ t.sessions }}
							</h6>
							<div class="element-box-tp">

								<!--------------------
START - Pipeline
-------------------->
								<div class="pipeline white" v-if="w <= 700 && status == 200" v-for="sess in sessions">
									<div class="pipeline-body">
										<div class="row p-0">
											<div class="col-6">
												<div class="listy b-b">
													<div class="label">
														{{ t.user.username }}
													</div>
													<router-link :to="{ name: 'userprofile', params: {id: sess.user.id} }">
														@{{ sess.user.username }}
													</router-link>
												</div>
											</div>
										</div>
									</div>
								</div>

								<table-component
										v-if="w > 700 && status == 200"
										table-class="table table-padded"
										filter-input-class="form-control col-4 float-right rounded bright"
										:data="sessions"
										sort-by="id"
										sort-order="desc"
								>
									<template>
										<table-column show="id" label="#" cell-class="w50"/>
										<table-column :label="t.user.username" cell-class="w50 px-2">
											<template slot-scope="row">
												<router-link :to="{ name: 'userprofile', params: {id: row.user.id} }">
													@{{ row.user.username }}
												</router-link>
											</template>
										</table-column>
										<table-column label="ip" cell-class="w50">
											<template slot-scope="row">
												<span :id="'c_'+row.id">{{ row.ip }}</span>
												<b-popover :target="'c_'+row.id" triggers="hover focus">
													<template slot="title">{{ t.detail }}</template>
													<div class="listy b-b">
														<span class="label">
															Hostname
														</span>
														{{ row.hostname }}
													</div>
													<div class="listy b-b">
														<span class="label">
															Location
														</span>
														{{ row.location }}
													</div>
													<div class="listy b-b">
														<span class="label">
															Region
														</span>
														{{ row.region }}
													</div>
													<div class="listy b-b">
														<span class="label">
															City
														</span>
														{{ row.city }}
													</div>
													<div class="listy b-b">
														<span class="label">
															Country
														</span>
														{{ row.country }}
													</div>
													<div class="listy b-b">
														<span class="label">
															Organization
														</span>
														{{ row.organization }}
													</div>
												</b-popover>
											</template>
										</table-column>
										<table-column show="agent" label="agent" cell-class="w150"/>
										<table-column :label="t.start_date" cell-class="w150 px-2">
											<template slot-scope="row">
												{{ row.createdAt | moment('D MMM ddd', session.timezone) | slimiter(10) }}
												<span class="smaller lighter">
												{{ row.createdAt | moment('HH:MM', session.timezone) | slimiter(10) }}
												</span>
											</template>
										</table-column>
										<table-column :label="t.end_date" cell-class="w150 px-2">
											<template slot-scope="row">
												{{ row.endedAt | moment('D MMM ddd', session.timezone) | slimiter(10) }}
												<span class="smaller lighter">
												{{ row.endedAt | moment('HH:MM', session.timezone) | slimiter(10) }}
												</span>
											</template>
										</table-column>
										<table-column cell-class="w50 text-center">
											<template slot-scope="row">
												<router-link :to="{ params: { id: row.id }, query: $route.query }">
													<i v-on:click="openSession(row)" class="icon-magnifier"></i>
												</router-link>
											</template>
										</table-column>
									</template>
								</table-component>

								<paginate v-if="pagination"
								          :page-count="pagination.pageCount"
								          :page-range="pagination.pageRange"
								          :force-page="(pagination.current-1)"
								          :margin-pages="2"
								          :click-handler="onChangePage"
								          :prev-text="t.previous"
								          :next-text="t.next"
								          :container-class="'pagination float-right'"
								          :page-class="'page-item'"
								          :page-link-class="'page-link'"
								          :prev-class="'page-item'"
								          :prev-link-class="'page-link'"
								          :next-class="'page-item'"
								          :next-link-class="'page-link'"
								>
								</paginate>

							</div>
						</div>
					</div>
				</div>
			</div>
			<!--------------------
			START - Sidebar
			-------------------->
			<div class="content-panel compact">
				<div class="content-panel-close" v-on:click="controlPanel()">
					<i class="os-icon os-icon-close"></i>
				</div>
				<div class="element-wrapper">
					<div class="element-actions actions-only" v-b-toggle.filter variant="primary">
							<span class="when-opened">
								<i class="os-icon os-icon-minus-circle"></i>
							</span>
							<span class="when-closed">
								<i class="os-icon os-icon-plus-circle"></i>
							</span>
					</div>
					<h6 class="element-header" v-b-toggle.filter variant="primary">
						{{ t.filter.title }}
					</h6>
					<div class="element-box-tp">
						<b-collapse id="filter" class="mt-2" expanded>
							<filterGenerator v-if="filter" :filter="filter"></filterGenerator>
						</b-collapse>
					</div>
				</div>

			</div>
			<!--------------------
			END - Sidebar
			-------------------->
		</div>

		<sweet-modal ref="session">
			<div class="text-left" v-if="sess">
				<div class="listy b-b">
					<span class="label">
						Hostname
					</span>
					{{ sess.hostname }}
				</div>
				<div class="listy b-b">
					<span class="label">
						Location
					</span>
					{{ sess.location }}
				</div>
				<div class="listy b-b">
					<span class="label">
						Region
					</span>
					{{ sess.region }}
				</div>
				<div class="listy b-b">
					<span class="label">
						City
					</span>
					{{ sess.city }}
				</div>
				<div class="listy b-b">
					<span class="label">
						Country
					</span>
					{{ sess.country }}
				</div>
				<div class="listy b-b">
					<span class="label">
						Organization
					</span>
					{{ sess.organization }}
				</div>
			</div>
		</sweet-modal>
	</div>
</template>

<script>

    import filterGenerator from '@/components/form/filter'
    import { TableComponent, TableColumn } from 'vue-table-component'
    export default {
        name: 'sessionList',
	    components: {TableComponent, TableColumn, filterGenerator},
        data () {
            return {
                filter: null,
                session: this.$root.session,
	            sess: null,
                isLoading: false,
                t: this.$root.t,
                sessions: null,
                w: window.innerWidth,
	            status: 0,
	            pagination: null,
            }
        },
	    watch: {
            '$route.query' () {
                this.fetchSessions()
            }
	    },
	    mounted () {
            this.setFilter()
            this.fetchSessions()
	    },
	    methods: {
            openSession (sess) {
				this.sess = sess;
				this.$refs.session.open()
            },
            fetchSession () {

            },
            onChangePage (page) {
                this.filter.model.page = page;
                this.pagination.current = page;
                this.$route.query.page = page;
                var qr = this.$route.query;
                this.$router.push({});
                this.$router.push({ query: qr });
                window.scroll(0, 0);
            },
            fetchSessions () {

                if (!this.isLoading) {
                    this.isLoading = true;
                    this.$http.get(api+'api/v1/sessions?direction=desc&sort=s.id', {params: this.filter.model}).then(response => {
                        // get body data
                        this.sessions = response.body.result.sessions;
	                    this.pagination = response.body.result.pagination;
	                    this.isLoading = false;
	                    this.status = response.status;

                }, response => {
                        this.isLoading = false;
                        this.status = response.status;
                    })


                }
            },
            filterNow: function() {
                this.pagination = null
                this.filter.model.page = 1;
                var model = this.$route.query;
                this.$router.push({ query: {} });
                this.$router.push({ query: this.filter.model });
                window.scrollTo(0,0);
            },
            setFilter () {
                this.filter = {
                    model: {
                        uid: '',
                        currency: [],
                        multiplier: [],
                        earnings: [],
                        createdAt: [],
                        type: 0,
	                    page: 1
                    },
                    schema: {
                        groups: [
                            {
                                legend: '',
                                fields: [
                                    {
                                        type: "input",
                                        inputType: "text",
                                        label: 'IP',
                                        model: "ip",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "Datepicker",
                                        class: 'test',
                                        label: this.t.time_range,
                                        model: "createdAt",
                                        readonly: false,
                                        featured: false,
                                        disabled: false,
                                        options: {
                                            not_before: null,
                                            clearable: true,
                                            range: true,
                                            firstDay: 1,
                                            format: 'YYYY-MM-DD',
                                            dataFormat: 'YYYY-MM-DD',
                                        }
                                    },
                                    {
                                        type: "User",
                                        inputType: "text",
                                        label: this.t.users,
                                        model: "user",
                                        multi: true,
                                        onlyId: true,
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "submit",
                                        label: "",
                                        buttonText: this.t.filter.title,
                                        onSubmit: this.filterNow,
                                        validateBeforeSubmit: false,
                                    }
                                ]
                            }
                        ],
                    },
                    options: {
                        validateAfterLoad: true,
                        validateAfterChanged: true
                    }
                }
            },
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sessions/list.vue